export default __webpack_public_path__ + "static/media/vice_president.035acfa3.jpg";